import { create } from "zustand";
import {
  Product,
  ProductsQuery,
  ProductsState,
} from "../types/product";
import { useFetcher } from "./fetcher";
import { Paging } from "../types/paging";
import { sortQueryFromOrderByRecord } from "../utils/query";

export const useProductsStore = create<ProductsState>(
  (set, get) =>
    ({
      items: [],
      total: null,
      query: null,
      limit: 20,
      showFilter: (() => { try { const v = localStorage.getItem('showFilter:products'); return v !== null ? JSON.parse(v) : true; } catch { return true; } })(),
      search: async (query?: ProductsQuery, fetch?: boolean) => {
        set(() => ({ query }));
        if (fetch !== false) {
          await get().fetch(true);
        }
      },
      fetch: async (reset: boolean): Promise<Paging<Product> | null> => {
        try {
          const { items, limit, query, total } = get();
          if (!reset && total !== null && total <= items.length ) {
            return null;
          }

          const sort = sortQueryFromOrderByRecord(query?.order_by)
          const params: any = query
            ? { ...query, order_by: undefined, sort, limit, offset: reset ? 0 : items.length }
            : { limit, offset: reset ? 0 : items.length };
          const res = await useFetcher
            .getState()
            .omsDsFetcher.get<Paging<Product>>("products", {
              params,
              paramsSerializer: {
                indexes: null,
              },
            });

          set(() => ({
            items: [...(reset ? [] : items), ...(res?.data?.items ?? [])],
            total: res?.data?.total ?? null,
          }));
          return res?.data ?? null;
        } catch (error) {
          throw error;
        }
      },
      get: async (id: string): Promise<Product | null> => {
        try {
          const res = await useFetcher
            .getState()
            .omsDsFetcher.get<Product>(`products/${id}`);
          return res?.data ?? null;
        } catch (error) {
          throw error;
        }
      },
      clear: () => {
        set(() => ({ items: [], total: null, query: null }));
      },
      setShowFilter: async (value: boolean): Promise<void> => {
        set(() => ({
          showFilter: value,
        }));
        try { localStorage.setItem('showFilter:products', JSON.stringify(value)); } catch {}
      },
    } as ProductsState)
);
